<template>
  <g>
    <path
      d="M19 6.00018V16.5002L20.95 18.4502C20.98 18.3002 21 18.1502 21 18.0002V6.00018C21 4.90018 20.1 4.00018 19 4.00018H6.5L8.5 6.00018H19Z"
    />
    <path
      d="M3.86001 3.95018C3.51001 3.60018 2.94001 3.60018 2.59001 3.95018C2.24001 4.30018 2.24001 4.87018 2.59001 5.22018L3.00001 5.64018V18.0002C3.00001 19.1002 3.90001 20.0002 5.00001 20.0002H17.36L18.78 21.4202C19.13 21.7702 19.7 21.7702 20.05 21.4202C20.4 21.0702 20.4 20.5002 20.05 20.1502L3.86001 3.95018ZM5.00001 18.0002V7.64018L15.36 18.0002H5.00001Z"
    />
  </g>
</template>
